// tslint:disable-next-line:no-reference
/// <reference path="../assets/assets.d.ts" />
import { css, InterpolationValue } from "styled-components";

const space = 8;

export const resPoint: {
  [key: string]: number;
} = {
  xl: 1600,
  lg: 1200,
  md: 1024.02,
  sm: 768,
  xs: 480,
};

const isMobile = (screenWidth: number) => screenWidth < resPoint.sm;

const isTablet = (screenWidth: number) => screenWidth < resPoint.md;

const isDesktop = (screenWidth: number) => screenWidth >= resPoint.md;

const isBigDesktop = (screenWidth: number) => screenWidth >= resPoint.lg;

export const mainWidth = 1140;

interface IAcc {
  [minWidth: string]: (
    args: TemplateStringsArray,
    ...placeHolders: any[]
  ) => InterpolationValue[];
}

export const media: {
  [key: string]: (
    args: TemplateStringsArray,
    ...placeHolders: any[]
  ) => InterpolationValue[];
} = Object.keys(resPoint).reduce((accumulator: IAcc, label: string) => {
  const result: any = accumulator;
  result[label] = (args: TemplateStringsArray, ...interpolations: any[]) => css`
    /* stylelint-disable-next-line media-query-no-invalid */
    @media (min-width: ${resPoint[label]}px) {
      ${css(args, ...interpolations)};
    }
  `;
  return result;
}, {});

export const mediaMax: {
  [key: string]: (
    args: TemplateStringsArray,
    ...placeHolders: any[]
  ) => InterpolationValue[];
} = Object.keys(resPoint).reduce((accumulator: IAcc, label: string) => {
  const result: any = accumulator;
  result[label] = (args: TemplateStringsArray, ...interpolations: any[]) => css`
    /* stylelint-disable-next-line media-query-no-invalid */
    @media (max-width: ${resPoint[label] - 0.02}px) {
      ${css(args, ...interpolations)};
    }
  `;
  return result;
}, {});

export { space, isTablet, isMobile, isDesktop, isBigDesktop };
